require('zenscroll');

function smoothScroll() {

}
export default smoothScroll;
